export enum HubSpotOptionsEnumUi {
  HELP_CENTER = 'HELP_CENTER',
  KNOWLEDGE_BASE = 'KNOWLEDGE_BASE',
  LIVE_SUPPORT = 'LIVE_SUPPORT',
  BUG_REPORT = 'BUG_REPORT',

  SALES = 'SALES',
  CONTACT_SALES = 'CONTACT_SALES',
}
